import Lottie from 'lottie-react';
import Questionaire from '../jsons/questionaire.json';


const LottieQuestionaire = props => {
  return <Lottie animationData={Questionaire} loop={false} {...props} />;
};

export default LottieQuestionaire;
